import * as React from "react"
import type { GatsbyBrowser, GatsbySSR } from "gatsby"
import { LangProvider, type Lang } from "./src/i18n"
import CookieConsent from "./src/components/CookieConsent"

type WrapPageElement =
  | GatsbyBrowser["wrapPageElement"]
  | GatsbySSR["wrapPageElement"]

export const wrapPageElement: WrapPageElement = ({ element, props }) => {
  const lang = (props.pageContext as { lang?: Lang })?.lang ?? "en"
  return (
    <LangProvider lang={lang}>
      {element}
      <CookieConsent />
    </LangProvider>
  )
}
